import { render, staticRenderFns } from "./AddExistingWorkflowGroup.vue?vue&type=template&id=0004a877&scoped=true"
import script from "./AddExistingWorkflowGroup.vue?vue&type=script&lang=js"
export * from "./AddExistingWorkflowGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004a877",
  null
  
)

export default component.exports